import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Utils from 'common/utils'
import Constants from 'common/constants'

export default class LastUpdatedView extends Component {
    constructor(props) {
        super(props)
        this.state = {
            lastUpdatedMessage: this.getLastUpdateStatusMsgForTime(props.since)
        }
        this.timeout = null
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (false === Utils.isNull(this.props.since) && prevProps.since !== this.props.since) {
            this.setState({
                lastUpdatedMessage: this.getLastUpdateStatusMsgForTime(this.props.since)
            })
        }
    }

    componentDidMount() {
        // Start the timer
        var periodicUpdates = () => {
            this.clearUpdateMsgTimeout()
            this.timeout = setTimeout(() => {
                this.setState({
                    lastUpdatedMessage: this.getLastUpdateStatusMsgForTime(this.props.since)
                })
                periodicUpdates()
            }, Constants.LAST_UPDATED_MSG_FREQ_TIMEOUT_MS);
        }
        periodicUpdates()
    }

    componentWillUnmount() {
        this.clearUpdateMsgTimeout()
    }

    render() {
        if (Utils.isEmptyStr(this.state.lastUpdatedMessage)) {
            return (
                <span></span>
            )
        }
        return (
            <span className="truncate-long-text last-updated">
                {this.state.lastUpdatedMessage}
            </span>
        )
    }

    // PRAGMA MARK :- Helpers

    clearUpdateMsgTimeout() {
        if (false === Utils.isNull(this.timeout)) {
            clearTimeout(this.timeout)
        }
    }

    getLastUpdateStatusMsgForTime(lastUpdatedTime) {
        var finalStateStr = "";
        if (false === Utils.isNull(lastUpdatedTime)) {
            var currTime = Date.now()
            var minsDiff = (((currTime - lastUpdatedTime) / 1000) / 60)
            if (minsDiff > 60) {
                finalStateStr = Constants.LAST_UPDATED_MSG.HOUR_AGO
            } else if (minsDiff > 10) {
                finalStateStr = Constants.LAST_UPDATED_MSG.MINS_AGO
            } else {
                finalStateStr = Constants.LAST_UPDATED_MSG.JUST_NOW
            }
        }
        return finalStateStr;
    }
}

LastUpdatedView.propTypes = {
    since: PropTypes.any.isRequired,
}


// WEBPACK FOOTER //
// ./src/components/lastUpdatedView.js